import nl from "date-fns/locale/nl";
import Vue from 'vue';
import { getShortLocaleCode } from "@/i18n";
import { format, parseISO } from 'date-fns'

var localize = getShortLocaleCode();

// Backend sends UTC timestamps without a timezone designator (e.g. "2026-05-30T07:00:00").
// Both `new Date()` and `parseISO` would read those as local time; append 'Z' so they are
// parsed as UTC and rendered in the browser's local zone. Date-only values (no 'T') are
// left alone - they are wall-clock dates and must not shift across a day boundary.
export function parseUtcIso(value) {
    if (typeof value !== 'string') {
        return value instanceof Date ? value : new Date(value);
    }
    const hasTime = /^\d{4}-\d{2}-\d{2}T/.test(value);
    const hasDesignator = /([zZ]|[+-]\d{2}:?\d{2})$/.test(value);
    return parseISO(hasTime && !hasDesignator ? `${value}Z` : value);
}

Vue.filter("dateLocalized", function (value, newFormat) {
    if (localize === 'nl') {
        return format(new Date(value), newFormat, { locale: nl });
    } else {
        return format(new Date(value), newFormat, null);
    }
})

// Same as `dateLocalized`, but for values that carry a time-of-day.
Vue.filter("dateTimeLocalized", function (value, newFormat) {
    if (!value) return '';
    return format(parseUtcIso(value), newFormat, localize === 'nl' ? { locale: nl } : null);
})
